/* eslint-disable @typescript-eslint/ban-ts-comment */
const logGaSignupEvent = (practitionerId, storeId) => {
  // @ts-ignore
  window.dataLayer?.push({ event: "practitioner-signup", practitionerId, storeId });
};

export { logGaSignupEvent };
